import { BASE_URL, request } from "./api";
import type {
  Appointment,
  AppointmentCreateDto,
  AppointmentUpdateDto,
} from "./types";

// Re-export types
export type { Appointment };

// GET /api/Appointment
export const getAppointments = async (): Promise<Appointment[]> => {
  return request<Appointment[]>(`${BASE_URL}/api/Appointment`, {
    method: "GET",
  });
};

export const createAppointment = async (
  data: AppointmentCreateDto
): Promise<Appointment> => {
  return request<Appointment>(`${BASE_URL}/api/Appointment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

export const getAppointmentById = async (id: number): Promise<Appointment> => {
  return request<Appointment>(`${BASE_URL}/api/Appointment/${id}`, {
    method: "GET",
  });
};

export const updateAppointment = async (
  id: number,
  data: AppointmentUpdateDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Appointment/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

export const deleteAppointment = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Appointment/${id}`, {
    method: "DELETE",
  });
};
